import { TrendClickAction } from '../../../elements/singleKpiTrend/types';
import { ContentInstructions, CoreContents, FromSettingsInstruction } from '../../../types';
import { DataOptionsFactory } from '../data';
import { ContentFactory } from './base';

export type SingleKpiTrendOptions = {
  data?: DataOptionsFactory;
  title?: string;
  asCard?: boolean;
  grouping: string | FromSettingsInstruction;
  kpi: string;
  secondaryKpi?: string;
  includeTotals?: boolean;
  totalName?: string;
  clickAction?: TrendClickAction;
  // isAllowedToDisplayEmptyState should be added on just one content to display the empty state when there is no data
  isAllowedToDisplayEmptyState?: boolean;
};

export class SingleKpiTrendFactory extends ContentFactory {
  constructor(options: SingleKpiTrendOptions) {
    const {
      data,
      title,
      asCard,
      grouping,
      kpi,
      secondaryKpi,
      includeTotals,
      totalName,
      clickAction,
      isAllowedToDisplayEmptyState,
    } = options;

    const instructions: ContentInstructions = {
      grouping:
        typeof grouping === 'string'
          ? {
              type: 'StringInstruction',
              instruction: grouping,
            }
          : grouping,
      kpi: {
        type: 'StringInstruction',
        instruction: kpi,
      },
      asCard: {
        type: 'BooleanInstruction',
        instruction: asCard || false,
      },
      includeTotals: {
        type: 'BooleanInstruction',
        instruction: includeTotals || false,
      },
      isAllowedToDisplayEmptyState: { type: 'BooleanInstruction', instruction: isAllowedToDisplayEmptyState },
    };

    if (title) {
      instructions.title = {
        type: 'StringInstruction',
        instruction: title,
      };
    }

    if (secondaryKpi) {
      instructions.secondaryKpi = {
        type: 'StringInstruction',
        instruction: secondaryKpi,
      };
    }

    if (totalName) {
      instructions.totalName = {
        type: 'StringInstruction',
        instruction: totalName,
      };
    }

    if (clickAction) {
      instructions.clickAction = {
        type: 'ObjectInstruction',
        instruction: clickAction,
      };
    }

    super(CoreContents.singleKpiTrend, {
      data: data || DataOptionsFactory.asReceiver(),
      instructions,
    });
  }
}
